@if (should_show_header) {
  <div class="section-header">
    {{ title }}
  </div>
}
@if (feedItems.length) {
  <app-carousel [config]="splideConfig">
    @for (item of feedItems; track item) {
      <app-slide (click)="openLink(item.link)">
        @if (isImage(item)) {
          <article [style.backgroundImage]="handleBackground(item.media_content)" [style.aspectRatio]="'1/1'">
            <footer class="media-description">
              <div class="account-info">
                <app-image [image_url]="profileImage(item)" width="42px" height="42px" border_radius="50%" margin="0.5rem"></app-image>
                <span> {{ item.user_full_name }} </span>
              </div>
              <div class="post-content" [innerHTML]="parseDesc(item.description, item.feed_type ? item.feed_type : '')"></div>
            </footer>
          </article>
        } @else {
          <article [style.aspectRatio]="'1/1'">
            <video [src]="item.media_content"></video>
            <footer class="media-description no-media-description">
              <div class="account-info">
                @if (item?.user_image) {
                  <app-image [image_url]="profileImage(item)" width="42px" height="42px" border_radius="50%" margin="0.5rem"></app-image>
                }
                <span> {{ item.user_full_name }} </span>
              </div>
              <div class="post-content no-media-content" [innerHTML]="parseDesc(item.description, item.feed_type ? item.feed_type : '')"></div>
              <div class="feed-date">{{ item.publication_date | date: 'shortTime' }} - {{ item.publication_date | date: 'mediumDate' }}</div>
            </footer>
          </article>
        }
      </app-slide>
    }
  </app-carousel>
}
